// Copyright (c) 2018 Deere & Company

import React, {PropTypes} from 'react';
import DragAndDrop from '../../drag-and-drop';
import ExcelLayoutModal from '../../../state/excel-layout-modal';
import {FormattedMessage} from 'react-intl';
import LabeledCheckbox from '../../../../claim/shared/components/claim-fields/labeled-checkbox';
import LabeledInputWithBlur from '../../../../claim/shared/components/claim-fields/labeled-input-with-blur';
import OptionsDropDown from '../../options-drop-down';
import getAvailableItems from '../services/get-available-items';
import isSaveDisabled from '../services/is-save-disabled';
import {sortDirectionOptions} from '../services/sort-direction-options';

/* eslint-disable complexity */

const ExcelLayoutModalBody = props => {

    const sortBySelectedValue = props.excelLayoutModal.excelLayout.sortBy.length ?
        props.excelLayoutModal.excelLayout.sortBy[0].column : '';

    const sortDirectionSelectedValue = props.excelLayoutModal.excelLayout.sortBy.length ?
        props.excelLayoutModal.excelLayout.sortBy[0].direction : '';

    return (
        <div className='excel-layout-modal-body modal-body'>
            <LabeledInputWithBlur
                className='layout-name'
                errorMessage='A_LAYOUT_WITH_THAT_NAME_ALREADY_EXISTS'
                isEditable={props.excelLayoutModal.isNewLayout}
                isValid={props.excelLayoutModal.isNameValid}
                label='LAYOUT_NAME'
                maxLength={30}
                onBlur={props.onLayoutNameBlur}
                onChange={props.onLayoutNameChange}
                type='text'
                value={props.excelLayoutModal.excelLayout.name}
            />
            <DragAndDrop
                availableItems={getAvailableItems(props.excelLayoutModal.availableColumns, props.excelLayoutModal.excelLayout.columns)}
                availableItemsLabel='AVAILABLE_COLUMNS'
                idAttribute='id'
                isDisplayValueMapped={true}
                mappingId={props.mappingId}
                mappingTable={props.mappingTable}
                onCardMove={props.onColumnMove}
                onCardPush={props.onColumnPush}
                onCardRemove={props.onColumnRemove}
                selectedItems={props.excelLayoutModal.excelLayout.columns}
                selectedItemsLabel='SELECTED_COLUMNS'
            />
            <div className='user-form-row'>
                <div className='sort-by-container'>
                    <label>
                        <FormattedMessage id='SORT_BY'/>
                    </label>
                    <div className='sort-by-fields'>
                        <OptionsDropDown
                            className='sort-by-dropdown'
                            isPlaceholderTranslated={false}
                            isRequired={false}
                            onChange={props.onSortByChange}
                            optionDisplayAttributes={['key']}
                            optionKey='id'
                            options={props.sortByList}
                            placeholder='SELECT_SORT_BY'
                            selectedValue={sortBySelectedValue}
                            showPlaceholder={true}
                        />
                        {sortBySelectedValue &&
                            <OptionsDropDown
                                className='sort-direction-dropdown'
                                isPlaceholderTranslated={false}
                                isRequired={false}
                                onChange={props.onSortDirectionChange}
                                optionDisplayAttributes={['value']}
                                optionKey='key'
                                options={sortDirectionOptions()}
                                placeholder='SELECT_SORT_DIRECTION'
                                selectedValue={sortDirectionSelectedValue}
                                showPlaceholder={false}
                            />
                        }
                    </div>
                </div>
                <LabeledCheckbox
                    className='set-as-default-checkbox'
                    id='set-as-default-checkbox'
                    isEditable={true}
                    isSelected={props.excelLayoutModal.excelLayout.isDefault}
                    label='SET_AS_DEFAULT'
                    onChange={props.onSetAsDefaultChange}
                    translationId={props.excelLayoutModal.excelLayout.isDefault ? 'YES' : 'NO'}
                />
            </div>
            <div className='user-form-row'>
                <div className='button-group'>
                    {!props.excelLayoutModal.isNewLayout &&
                        <button onClick={props.onLayoutDelete}>
                            <FormattedMessage id='DELETE'/>
                        </button>
                    }
                    <button onClick={props.onCancel}>
                        <FormattedMessage id='CANCEL'/>
                    </button>
                    <button
                        className='button-primary'
                        disabled={isSaveDisabled(props.excelLayoutModal.excelLayout.name, props.excelLayoutModal.isNameValid, props.excelLayoutModal.excelLayout.columns)}
                        onClick={props.onSaveLayout}
                    >
                        <FormattedMessage id='SAVE'/>
                    </button>
                </div>
            </div>
        </div>
    );

};

ExcelLayoutModalBody.displayName = 'ExcelLayoutModalBody';
ExcelLayoutModalBody.propTypes = {
    excelLayoutModal: PropTypes.instanceOf(ExcelLayoutModal).isRequired,
    mappingId: PropTypes.string,
    mappingTable: PropTypes.arrayOf(PropTypes.object),
    onCancel: PropTypes.func.isRequired,
    onColumnMove: PropTypes.func.isRequired,
    onColumnPush: PropTypes.func.isRequired,
    onColumnRemove: PropTypes.func.isRequired,
    onLayoutDelete: PropTypes.func.isRequired,
    onLayoutNameBlur: PropTypes.func.isRequired,
    onLayoutNameChange: PropTypes.func.isRequired,
    onSaveLayout: PropTypes.func.isRequired,
    onSetAsDefaultChange: PropTypes.func.isRequired,
    onSortByChange: PropTypes.func.isRequired,
    onSortDirectionChange: PropTypes.func.isRequired,
    sortByList: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default ExcelLayoutModalBody;

/* eslint-enable complexity */



// WEBPACK FOOTER //
// ./src/shared/components/excel-layout/excel-layout-modal/excel-layout-modal-body.js